
interface Dictionary<T> {
    [Key: string]: T;
}
export class UserAccessRoleRules {
    rules: Dictionary<string[]>;
}
